<template>
  <div id="printerDivOrderLog" class="ml-3 mt-3">
    <span class="m-4 w-full block h5 bold">{{companyName}} Ciro Raporu</span>
    <span class="m-2 w-full block">Tarih : {{reportDate}}</span>
    <vs-table id="totalOrderLogPrintTable" ref="table" :data="sumOfOrders" class="w-full">

      <template slot="thead">

        <vs-th class="w-6/12">
          <p>Ödeme</p>
        </vs-th>
        <vs-th class="w-3/12">
          <p>Adet</p>
        </vs-th>
        <vs-th class="w-3/12">
          <p>Tutar</p>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
            :class="{'row-bg-danger' : tr.effect == 'Negatif', 'row-bg-warning' : tr.effect == 'Nötr'}">

            <vs-td class="w-6/12">
              <p class="font-medium truncate">{{ tr.paymentName }}</p>
            </vs-td>

            <vs-td class="w-3/12">
              <p class=" font-medium truncate">{{ tr.totalCount }}</p>
            </vs-td>

            <vs-td class="w-3/12">
              <p class=" font-medium truncate">{{ $toCurrency(tr.totalPrice) }}</p>
            </vs-td>


          </vs-tr>
          <vs-tr v-if="sumOfExpenses.length > 0" class="row-bg-danger">
            <vs-td class="w-6/12">
              <p class="font-medium truncate">Gider</p>
            </vs-td>
            <vs-td class="w-3/12">
              <p class="font-medium truncate">{{sumOfExpenses.length}}</p>
            </vs-td>
            <vs-td class="w-3/12">
              <p class="font-medium truncate">{{ $toCurrency(getTotalExpensePrice) }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <div class="flex justify-flex-end">
      <span class="h5">Toplam Net Ciro :</span>
      <span class="h4 text-primary bold ml-3">{{ $toCurrency(getTotalPrice) }}</span>
    </div>
  </div>
</template>
<script src="https://www.google.com/cloudprint/client/cpgadget.js" />
<script>
  import print from 'print-js';
import companyInfo from '../../../../model/constants/companyInfo';
  export default {
    props: {
      sumOfOrders: {
        type: Array,
        required: false
      },
      sumOfExpenses: {
        type: Array,
        required: false
      },
      getTotalPrice:{
        type:Number,
        required:false
      },
      getTotalExpensePrice:{
        type:Number,
        required:false
      },
      reportDate:{
        type: String,
        required:false
      }
    },
    data() {
      return {
companyName: companyInfo.name
      }
    },
    methods: {
      printTotalOrderLogs() {
        try {
          printJS({
            showModal:false,
            printable: 'printerDivOrderLog',
            type: 'html',
            targetStyles: ["*"]
          });
        } catch (e) {}
      },
    }
  }

</script>

<style>
  #totalOrderLogPrintTable div table thead tr th,
  #totalOrderLogPrintTable div table tbody tr td {
    padding: 0 !important;
  }

  #totalOrderLogPrintTable div table {
    min-width: unset !important;
  }
  #printerDivOrderLog {
    position: absolute;
    left: -5%;
    top: 5%;
    font-size: 15px;
    max-width: 80mm;
    z-index: -1;
    min-height: 150mm;
  }

</style>
